import {call, put} from "redux-saga/effects";
import {localReferentielApi} from "../../apis/localReferentielApi";
import * as actions from "../state/localReferentielActions";

export function* localReferentielSaga({ referentielKey }) {
  try {
    const response = yield call(localReferentielApi, referentielKey);
    yield put(
      actions.localReferentielSuccessAction(referentielKey)(response.data.body)
    );
  } catch (error) {
    yield put(actions.localReferentielFailAction(referentielKey)(error));
  }
}
